var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.74,8.54h-8.5A2.26,2.26,0,0,0,9,10.8v8.94A2.26,2.26,0,0,0,11.24,22h8.5A2.26,2.26,0,0,0,22,19.74V10.8A2.26,2.26,0,0,0,19.74,8.54Zm.17,11.2a.18.18,0,0,1-.17.18h-8.5a.18.18,0,0,1-.18-.18V10.8a.18.18,0,0,1,.18-.18h8.5a.18.18,0,0,1,.17.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09,13.2V4.26a.18.18,0,0,1,.17-.18h8.5a.18.18,0,0,1,.18.18V7.08H15V4.26A2.26,2.26,0,0,0,12.76,2H4.26A2.26,2.26,0,0,0,2,4.26V13.2a2.26,2.26,0,0,0,2.26,2.26H7.52V13.38H4.26A.18.18,0,0,1,4.09,13.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b6adf339ca0e68f58d1239ca9294f153.svg";
export { ForwardRef as ReactComponent };